import { render, staticRenderFns } from "./PageEditSectors.vue?vue&type=template&id=658c0d49&"
import script from "./PageEditSectors.vue?vue&type=script&lang=ts&"
export * from "./PageEditSectors.vue?vue&type=script&lang=ts&"
import style0 from "./PageEditSectors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VContainer,VForm,VTextField})
